import React, { useEffect, useState } from 'react';
import Breadcrumbs from '../../components/BreadCrumbs';
import Card from '../../components/cards/Card';
import StyledHeadingText from '../../components/Fonts/StyledHeadingText';
import SearchBar from '../../components/searchBar/SearchBar';
import { Link } from 'react-router-dom';
import Button from '../../components/buttons/Button';
import { toast } from 'react-toastify';
import { BiEdit, BiLink, BiRefresh } from 'react-icons/bi';
import CustomLoading from '../../components/customLoading/CustomLoading';
import Table from '../../components/tables/Table';
import Pagination from '../../components/tables/pagination/Pagination';
import { getManufacturers, patchManufacturer } from '../../services/manufacturer';

function Manufacturers() {
    const [cardData, setCardData] = useState([]);

    const [loading, setLoading] = useState(true);
    const [data, setData] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const headers = [
        { label: "Products", key: "product_count" },
        { label: "Name", key: "name" },
        { label: "Image", key: "image" },
        { label: "Banner", key: "banner" },
        { label: "Reg. No.", key: "registration_number" },
        { label: "Tax ID", key: "tax_id" },
        { label: "Contact", key: "contact_information" },
        { label: "Address", key: "address" },
        { label: "Website", key: "website" },
        { label: "Active", key: "is_active" },
        { label: "Action", key: "action" },
    ];

    const [searchText, setSearchText] = useState("");

    const pageSize = 10;

    const handleSearch = (query) => {
        setSearchText(query);
        fetchData(`?search=${query}`);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const fetchData = async (query) => {
        setLoading(true);
        try {
            let res = await getManufacturers(query);
            if (res.status === 200) {
                const data = res.data;
                setData(data);
            } else {
                toast.error("Unable to fetch Data");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error in Manufacturers:", error);
        } finally {
            setLoading(false);
        }
    };

    const resetFilters = () => {
        setSearchText("");
        fetchData("");
    };

    useEffect(() => {
        fetchData("");
    }, []);

    const handleIsActive = async (it, value) => {
        try {
            let res = await patchManufacturer({
                id: it.id,
                data: {
                    is_active: value,
                },
            });
            if (res.status === 200) {
                toast.success("Updated Today's Offer");
                data.results.map((item, index) => {
                    if (item.id === it.id) {
                        item.is_active = value;
                    }
                });
                setData({ ...data });
            } else {
                toast.error("Unable to update Offer");
            }
        } catch (error) {
            console.error("Error Updating Popup:", error);
        }
    };

    return (<>
        <Breadcrumbs items={[
            { name: 'Home', link: '/dashboard' },
            { name: 'Bazaar' },
            { name: 'Manufacturers' },
        ]} />
        <div className="py-3">
            <StyledHeadingText text={"Manufacturers"} />
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4 mt-2">
                {cardData.map((card, index) => (
                    <Card title={card.title} count={card.count} />
                ))}
            </div>
        </div>
        <div className="flex flex-row justify-between item-center">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 justify-center items-center max-w-4xl">
                <SearchBar placeholder="Search Name" onSearch={handleSearch} value={searchText} />
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-4 justify-center items-center">
                    <div className="flex flex-row items-center gap2">
                        {
                            searchText.length !== 0 ?
                                <BiRefresh size={24} className='cursor-pointer text-primary' onClick={resetFilters} /> : <></>
                        }
                    </div>
                </div>
            </div>
            <Link to="/bazzar/manufacturer/add" className='self-center'>
                <Button
                    type="button"
                    className="hover:bg-black hover:opacity-70 text-white bg-black rounded-md"
                >
                    Add Manufacturer
                </Button>
            </Link>
        </div>
        {
            loading ?
                <div className="flex w-full flex-row justify-center my-2">
                    <CustomLoading size={100} />
                </div>
                :
                <div className="mt-2">
                    <Table
                        headers={headers}
                        rows={data?.results?.map((item, index) => (
                            {
                                product_count: <p>{item.product_count}</p>,
                                name: <p>{item.name}</p>,
                                image: <img src={item.image} alt={item.image} className='w-12 aspect-square rounded-sm border object-contain' />,
                                banner: <img src={item.banner} alt={item.banner} className='w-20 aspect-video rounded-sm border object-contain' />,
                                registration_number: <p>{item.registration_number}</p>,
                                tax_id: <p>{item.tax_id}</p>,
                                is_active: <label className="relative inline-flex items-center cursor-pointer">
                                    <input
                                        type="checkbox"
                                        checked={item.is_active}
                                        onChange={(e) => handleIsActive(item, e.target.checked)}
                                        className="sr-only peer"
                                    />
                                    <div className="w-11 h-6 bg-gray-300 peer-checked:bg-primary rounded-full transition-all duration-300" />
                                    <div className="absolute left-1 top-1 w-4 h-4 bg-white rounded-full transition-all duration-300 peer-checked:translate-x-5" />
                                </label>,
                                contact_information: <span className='flex flex-row gap-1 items-center'><p className="max-w-16 truncate cursor-help" title={item.contact_information}>{item.contact_information}</p></span>,
                                address: <span className='flex flex-row gap-1 items-center'><p className="max-w-16 truncate cursor-help" title={item.address}>{item.address}</p></span>,
                                website: <Link to={item.website} target='_blank' ><BiLink size={24} color='blue' /></Link>,
                                action: <Link to={`/bazzar/manufacturer/${item.name}/`} state={item}><BiEdit size={24} color='green' /></Link>,
                            }))}
                    />
                </div>}
        {/* Table End */}
        {/* Pagination Begin */}
        {
            data.count !== 0 ?
                <Pagination
                    currentPage={currentPage}
                    
                    pageSize={pageSize}
                    totalEntries={data?.count}
                    onPageChange={handlePageChange}
                    data={data}
                    setData={setData}
                /> : <></>
        }
    </>);
}

export default Manufacturers;